import { createContext, useEffect, useState } from "react";

export const CoachContext = createContext();

export const CoachProvider = ({ children }) => {
  const [values, setValues] = useState([]);

  useEffect(() => {
    console.log(values);
  }, [values]);

  const saveValue = (name, title, value, group = "", subGroup = "") => {
    setValues((oldArray) => [
      ...oldArray,
      { name, title, group, subGroup, value },
    ]);
  };

  const removeValue = (name) => {
    setValues(values.filter((value) => value.name !== name));
  };

  const modifyAmount = (title, value) => {
    setValues((oldArray) =>
      oldArray.map((fields) => {
        if (fields.title === title) {
          return {
            name: fields.name,
            title,
            value,
            group: fields.group,
            subGroup: fields.subGroup,
          };
        } else return fields;
      })
    );
  };

  const getValue = (name) => values.find((value) => name === value.name);

  const getValues = () => values;

  const clearValues = () => {
    setValues([]);
  };

  useEffect(() => {
    clearValues();
  }, []);

  return (
    <CoachContext.Provider
      value={{
        values,
        saveValue,
        removeValue,
        getValue,
        getValues,
        modifyAmount,
      }}
    >
      {children}
    </CoachContext.Provider>
  );
};
